import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import { isAdminNotConsultant } from "@/js/http/auth.js";
import { displayPrice } from "@/js/currency/currencies.js";
export default {
  name: "WineDiscountTooltip",
  props: {
    wine: {
      type: Object
    },
    casingId: {
      type: String,
      default: ""
    },
    currency: {
      type: String,
      default: "EUR"
    }
  },
  data: function data() {
    return {
      casing: 1,
      loggedUserData: {}
    };
  },
  created: function created() {
    if (this.wine) {
      this.casing = this.casingId ? this.casingId.match(/\d+/)[0] : this.wine.casings.find(function (x) {
        return x.isDefault;
      }).quantity;
    }
  },
  methods: {
    displayPrice: displayPrice,
    isAdminNotConsultant: isAdminNotConsultant
  }
};